import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartRoutingModule } from './cart-routing.module';
import { CartDetailsComponent } from './cart-details/cart-details.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { SharedModule } from './../../shared/shared.module';
import { BillingComponent } from './billing/billing.component';
import { OrderPreviewComponent } from './order-preview/order-preview.component';
import { PaymentComponent } from './payment/payment.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SuccessorderComponent } from './successorder/successorder.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [CartDetailsComponent, BillingComponent, OrderPreviewComponent, PaymentComponent, SuccessorderComponent],
  imports: [
    CommonModule,
    CartRoutingModule,
    SharedModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),
  ]
})
export class CartModule { }
